import { QueryClient } from 'react-query';
import { querySettings } from 'services/query-settings';

export const queryClient = new QueryClient(querySettings);
